// extracted by mini-css-extract-plugin
export var above250Subtext = "planCard-module--above250Subtext--33472";
export var amount = "planCard-module--amount--afef2";
export var asterisk = "planCard-module--asterisk--59e8f";
export var below250Card = "planCard-module--below250Card--17a37";
export var button = "planCard-module--button--12327";
export var buttonContainer = "planCard-module--buttonContainer--cc414";
export var buttons = "planCard-module--buttons--7c6a6";
export var cardContents = "planCard-module--cardContents--514c3";
export var collapsible = "planCard-module--collapsible--bfeb5";
export var collapsibleContainer = "planCard-module--collapsibleContainer--60574";
export var contactButton = "planCard-module--contactButton--056c5";
export var description = "planCard-module--description--80b13";
export var disclaimer = "planCard-module--disclaimer--fd0a9";
export var disclaimerText = "planCard-module--disclaimerText--b1019";
export var divider = "planCard-module--divider--04355";
export var emailAndFreeCard = "planCard-module--emailAndFreeCard--ae304";
export var emailSendsContainer = "planCard-module--emailSendsContainer--a9a21";
export var emailSendsPlusContainer = "planCard-module--emailSendsPlusContainer--503df";
export var emailSendsText = "planCard-module--emailSendsText--23dda";
export var featuresListContainer = "planCard-module--featuresListContainer--5d0ad";
export var flameIcon = "planCard-module--flameIcon--20c81";
export var freeAmount = "planCard-module--freeAmount--fec24";
export var freeCardEmailSends = "planCard-module--freeCardEmailSends--e1650";
export var freeCardEyebrow = "planCard-module--freeCardEyebrow--d3019";
export var freeCardPlanNameContainer = "planCard-module--freeCardPlanNameContainer--0166b";
export var freeCardStats = "planCard-module--freeCardStats--eb4ee";
export var freeCardStatsContainer = "planCard-module--freeCardStatsContainer--c6133";
export var freeText = "planCard-module--freeText--787e6";
export var iconDown = "planCard-module--iconDown--97963";
export var iconUp = "planCard-module--iconUp--e9a6f";
export var planCard = "planCard-module--planCard--e5505";
export var planName = "planCard-module--planName--8b8e2";
export var planNameContainer = "planCard-module--planNameContainer--a01e8";
export var priceEyebrow = "planCard-module--priceEyebrow--68978";
export var priceWrapper = "planCard-module--priceWrapper--34293";
export var recommended = "planCard-module--recommended--15642";
export var recommendedText = "planCard-module--recommendedText--afb4d";
export var redCardStatsContainer = "planCard-module--redCardStatsContainer--f9082";
export var smsSubText = "planCard-module--smsSubText--1475f";
export var start = "planCard-module--start--e99b1";
export var statsContainer = "planCard-module--statsContainer--faa70";
export var text = "planCard-module--text--d8927";
export var timePeriod = "planCard-module--timePeriod--6228c";